import React from 'react';

import { LegacyPositionIcon, LegacyProfitTableIcon, LegacyReportsIcon, LegacyStatementIcon } from '@deriv/quill-icons';
import { routes } from '@deriv/shared';
import { localize } from '@deriv-com/translations';

import Endpoint from 'Modules/Endpoint';

// Error Routes
const Page404 = React.lazy(() => import(/* webpackChunkName: "404" */ 'Modules/Page404'));

const MenuPage = React.lazy(() => import(/* webpackChunkName: "menu" */ 'Modules/Menu'));

const Trader = React.lazy(() => import(/* webpackChunkName: "trader" */ '@deriv/trader'));

const Reports = React.lazy(() => import(/* webpackChunkName: "reports" */ '@deriv/reports'));

// eslint-disable-next-line import/no-unresolved
const ClientsAnalysis = React.lazy(() => import(/* webpackChunkName: "clients-analysis" */ 'Modules/ClientsAnalysis'));

const Bot = React.lazy(() => import(/* webpackChunkName: "bot-web-ui-app" */ '@deriv/bot-web-ui'));

const getModules = () => {
    const modules = [
        {
            path: routes.reports,
            component: Reports,
            getTitle: () => localize('Reports'),
            icon_component: <LegacyReportsIcon />,
            protected: true,
            routes: [
                {
                    path: routes.positions,
                    component: Reports,
                    getTitle: () => localize('Open positions'),
                    icon_component: <LegacyPositionIcon />,
                    default: true,
                    protected: true,
                },
                {
                    path: routes.profit,
                    component: Reports,
                    getTitle: () => localize('Trade table'),
                    icon_component: <LegacyProfitTableIcon />,
                    protected: true,
                },
                {
                    path: routes.statement,
                    component: Reports,
                    getTitle: () => localize('Statement'),
                    icon_component: <LegacyStatementIcon />,
                    protected: true,
                },
            ],
        },
        {
            path: routes.menu,
            component: MenuPage,
            getTitle: () => localize('Menu'),
            protected: false,
        },
        {
            path: routes.trader,
            component: Trader,
            getTitle: () => localize('Trader'),
            protected: false,
        },
        {
            path: routes.trader_positions,
            component: Trader,
            getTitle: () => localize('Positions'),
            protected: true,
        },
        {
            // Bot builder is the home page (routes.bot === routes.index === '/').
            path: routes.bot,
            exact: true,
            component: Bot,
            getTitle: () => localize('Bot'),
            protected: false,
        },
        {
            path: routes.contract,
            component: Trader,
            getTitle: () => localize('Contract Details'),
            protected: true,
        },
    ];

    return modules;
};

// Order matters
// TODO: search tag: test-route-parent-info -> Enable test for getting route parent info when there are nested routes
const initRoutesConfig = () => [
    { path: routes.endpoint, component: Endpoint, getTitle: () => 'Endpoint' }, // doesn't need localization as it's for internal use
    { path: routes.clients_analysis, component: ClientsAnalysis, getTitle: () => localize('Clients Analysis') },
    ...getModules(),
];

let routesConfig;

// For default page route if page/path is not found, must be kept at the end of routes_config array
const route_default = { component: Page404, getTitle: () => localize('Error 404') };

const getRoutesConfig = () => {
    if (!routesConfig) {
        routesConfig = initRoutesConfig();
        routesConfig.push(route_default);
    }
    return routesConfig;
};

export default getRoutesConfig;
